import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const CallCentersHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-32 pb-24 px-6 overflow-hidden">
      <div className="relative z-20 max-w-7xl mx-auto">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight text-white">
            Built for High-Volume Contact Centers
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-semibold mb-4">
            All Aboard Smarter Enablement
          </p>

          <p className="text-lg text-cyan-400 font-semibold mb-8">
            Powered by Traain's Navigator AI™
          </p>

          <p className="text-lg md:text-xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed">
            Train agents faster. Practice smarter. Perform consistently — across every conversation.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={openCalendly}
              className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
              data-testid="callcenters-hero-demo-btn"
            >
              See Traain for Contact Centers
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default CallCentersHero;
